import { useQuery } from '@tanstack/react-query'

import { getList } from '../query/get-list'

/**
 * Справочник федеральных округов вместе с состояниями показа: идёт загрузка, случился отказ,
 * можно повторить. Шлёт запрос на сервер; при `isNeeded = false` запрос не уходит вовсе —
 * так формы не тянут перечень, когда он им не нужен (например, продавец не выбрал FBS).
 */
export const useFederalDistricts = (isNeeded = true) => {
  const query = useQuery({ ...getList(), enabled: isNeeded })
  const districts = query.data
  // Загруженные данные не прячем из-за ошибки фонового обновления, а повтор считаем загрузкой.
  const hasLoadError = isNeeded && !districts && query.isError && !query.isFetching

  return {
    districts,
    isLoading: isNeeded && !districts && !hasLoadError,
    hasLoadError,
    retry: () => {
      if (isNeeded) {
        void query.refetch()
      }
    },
  }
}
